import APIService from '../../services/api'
import {Cookies} from 'react-cookie';
import {
    REPORTS_PENDING,
    REPORTS_FAILED,
    REPORTS_DOWNLOADED,
    REPORTS_RESET,
    REPORT_FOCUS,
    REPORT_DELETING,
    REPORT_DELETED,
    REPORT_ITEM_POSTING,
    REPORT_ITEM_PICTURE_POSTING,
    REPORT_ITEM_DELETING,
    REPORT_DOWNLOADED,
    REPORT_ITEM_DOWNLOADED,
    REPORT_EDITING
} from "./types";
import {handleError} from "../infos/actions";
import {
    uploadMediaAction,
    uploadMediaFailedAction,
    uploadMediaSucceedAction
} from "../points/actions";

const cookies = new Cookies();

export const reportResetAction = () => {
    return {
        type: REPORTS_RESET
    }
};

export const reportPendingAction = () => {
    return {
        type: REPORTS_PENDING
    }
};

export const reportsDownloadedAction = (reports) => {
    return {
        type: REPORTS_DOWNLOADED,
        payload: reports
    }
};

export const reportDownloadedAction = (report) => {
    return {
        type: REPORT_DOWNLOADED,
        payload: report
    }
};

export const reportFocusAction = (report) => {
    return {
        type: REPORT_FOCUS,
        payload: report
    };
};

export const reportDeletedAction = (report) => {
    return {
        type: REPORT_DELETED,
        payload: report
    }
};

export const reportEditingAction = () => {
    return {
        type: REPORT_EDITING
    }
};

export const reportDeletingAction = () => {
    return {
        type: REPORT_DELETING
    }
};

export const reportItemPostingAction = () => {
    return {
        type: REPORT_ITEM_POSTING
    }
};

export const reportItemDownloadedAction = (report, item) => {
    return {
        type: REPORT_ITEM_DOWNLOADED,
        payload: {report: report, item: item}
    }
};

export const reportItemImagePostingAction = () => {
    return {
        type: REPORT_ITEM_PICTURE_POSTING
    }
};

export const reportItemDeletingAction = () => {
    return {
        type: REPORT_ITEM_DELETING
    }
};

// Actions

export function getReports(app, lang) {
    return function (dispatch) {
        dispatch(reportPendingAction());
        return APIService
            .getReports(app, cookies.get('token'), lang)
            .then(reports => {
                dispatch(reportsDownloadedAction(reports, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, REPORTS_FAILED))
            });
    };
}

export function fetchReport(appId, reportId, lang) {
    return function (dispatch, getState) {
        let reports = getState().reports.content;
        if (reports !== undefined) {
            let report = reports.find(function (report) {
                return report.id === reportId
            });
            if (report !== undefined && report) {
                return dispatch(reportFocusAction(report));
            }
        }
        return dispatch(getReport(appId, reportId, lang));
    };
}

export function getReport(appId, reportId, lang) {
    return function (dispatch) {
        dispatch(reportPendingAction());
        return APIService
            .getReport(appId, reportId, cookies.get('token'), lang)
            .then(report => {
                dispatch(reportDownloadedAction(report, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, REPORTS_FAILED))
            });
    };
}

export function putReport(appId, report, lang) {
    return function (dispatch) {
        dispatch(reportEditingAction());
        return APIService
            .putReport(appId, report, cookies.get('token'), lang)
            .then(report => {
                dispatch(reportDownloadedAction(report, lang));
                return report;
            })
            .catch((error) => {
                dispatch(handleError(error, REPORTS_FAILED))
                return null;
            });
    };
}

export function deleteReport(appId, reportId, lang) {
    return function (dispatch) {
        dispatch(reportDeletingAction());
        return APIService
            .deleteReport(appId, reportId, cookies.get('token'), lang)
            .then(() => {
                dispatch(reportDeletedAction(reportId, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, REPORTS_FAILED))
            });
    };
}

export function resetReport() {
    return function (dispatch) {
        dispatch(reportResetAction());
    }
}

export function postReportMedia(appId, reportId, media, lang, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(uploadMediaAction(media));
        return APIService
            .postReportMedia(appId, reportId, media, cookies.get('token'), lang, onUploadProgress)
            .then(report => {
                dispatch(reportDownloadedAction(report, lang));
                dispatch(uploadMediaSucceedAction(media));
            })
            .catch((error) => {
                dispatch(handleError(error));
                dispatch(uploadMediaFailedAction(media));
            });
    }
}

export function postReportItem(appId, report, item, lang, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(reportItemPostingAction());
        return APIService
            .postReportItem(appId, report.id, item, cookies.get('token'), lang, onUploadProgress)
            .then(report => {
                dispatch(reportItemDownloadedAction(report, item));
                return report;
            })
            .catch((error) => {
                dispatch(handleError(error));
                return null;
            });
    }
}
export function postReportItemMedia(appId, report, item, media, lang, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(reportItemImagePostingAction());
        return APIService
            .postReportItemMedia(appId, report.id, item.id,media, cookies.get('token'), lang, onUploadProgress)
            .then(report => {
                dispatch(reportItemDownloadedAction(report, item));
                return report;
            })
            .catch((error) => {
                dispatch(handleError(error));
                return null;
            });
    }
}





// WEBPACK FOOTER //
// src/store/reports/action.js